import { doc } from 'firebase/firestore';
import React from 'react'
import { useFirestore, useFirestoreDocDataOnce } from "reactfire";

import { Icon } from "@iconify/react";
import copyIcon from "@iconify/icons-ic/content-copy";
import toast from 'react-hot-toast';

const DonationSuccessPageStep2 = () => {

    const donateQuoteRef = doc(useFirestore(), "app/donate-page-quote");
    const {status, data} = useFirestoreDocDataOnce(donateQuoteRef);

    if(status == "loading") {
        return <div>Please wait...</div>;
    }

    const quote = data.quote || ""
    const quoteSource = data.quoteSource || "";
    const quoteHE = data.quoteHE || ""
    const quoteSourceHE = data.quoteSourceHE || "";
    

    const shareThisPage = async () => {
        // const input = document.createElement("input")
        // input.value = "https://r24.page.link/donate-link"
        
        // input.select();
        // input.setSelectionRange(0, 99999);

        // await navigator.clipboard.writeText(input.value);
        
        // toast.success("Link Copied!");

        try {
          window?.flutter_inappwebview?.callHandler('handlerShare')
            ?.then(function(result) {
              // print to the console the data coming
              // from the Flutter side.
              // console.log(JSON.stringify(result));
          });
        } catch (error) {
          console.log(error);
        }

        const canShare = navigator.canShare({
            url: "https://r24.page.link/donate-link"
        })

        if(canShare) {
            await navigator.share({
                url: "https://r24.page.link/donate-link"
            });
        } else {
          try {
            window?.flutter_inappwebview?.callHandler('handlerShare')
              ?.then(function(result) {
                // print to the console the data coming
                // from the Flutter side.
                // console.log(JSON.stringify(result));
            });
          } catch (error) {
            console.log(error);
          }
        }
    }

    return (
      <div
        className="w-full bg-blue-50 h-screen"
        style={{
          backgroundImage: "url('/assets/donate_page/donate_page_bg.webp')",
        }}
      >
        <div className="w-11/12 sm:mt-0 mx-auto shadow-2xl md:w-1/2 rounded-3xl bg-white px-8 py-6 flex flex-col items-center justify-center">
          <div className="relative w-full">
            <p className="text-center font-bold">In the Rebbe's Words:</p>
            <img
              src="/assets/donate_page/quote.png"
              alt="quote"
              className="absolute top-0 right-0 h-8"
            />

            <div className="mt-4">
              <img
                src="/assets/donate_page/photo.png"
                alt="photo"
                className="w-32 h-32 block float-left p-2"
              />

              <p className="">{quote}</p>
            </div>

            <div className="flex mt-4 gap-2">
              <img
                src="/assets/donate_page/quote.png"
                alt="quote"
                className="block h-6"
              />
              <p className="text-sm text-gray-500">{quoteSource}</p>
            </div>
          </div>

          <div className="mt-6">
            <img
              src="/assets/donate_page/donate_page_logo.jpg"
              alt="logo"
              className="w-32 h-32 object-contain"
            />
          </div>

          <p className="mt-4 text-2xl text-center">
            Thank You for Your Support!
          </p>

          <div>
            <img
              src="/assets/donate_page/sign.png"
              alt="sign"
              className="h-16 object-contain mt-4"
            />
          </div>

          <p className="text-center mt-4">
            Rabbi Shneor Lieder
            <br />
            Tomchei Temimim Beit Shemesh (Israel)
          </p>

          <button
            onClick={shareThisPage}
            className="mt-6 bg-sky-100 hover:bg-sky-200 text-sky-600 px-8 py-3 rounded-full"
          >
            Share This Page
          </button>
        </div>
      </div>
    );
}

export default DonationSuccessPageStep2